import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, formatDate } from "../../utils/const";
import { useEffect, useState } from "react";
import styles from "./MassMailing.module.css";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllRecruiterCandidateNextPrevious,
  postMassmail,
} from "../../redux/massmail/massmailSlice";
import { allLocation } from "../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../redux/common/workAuthorizationSlice";

function ActiveCandidateDrawer({
  handleClose,
  show,
  jobID,
  valueData,
  candidateData,
}) {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [creditCount, setCreditCount] = useState(0);

  const locations = useSelector((state) => state.location) || [];
  const workautho = useSelector((state) => state.workautho);
  const massmailStatus = useSelector((state) => state.massmail.status);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const allCandidates = candidateData?.results?.flatMap(
    (recruiter) => recruiter?.candidates
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();
  // const toggleSelect = (id, credit) => {
  //   setSelectedCandidates((prev) =>
  //     prev?.includes(id) ? prev?.filter((cid) => cid !== id) : [...prev, id]
  //   );

  //   setCreditCount((prev) =>
  //     prev?.includes(id) ? prev - credit : prev + credit
  //   );

  // };

  const toggleSelect = (id, credit) => {
    setSelectedCandidates((prev) => {
      const isSelected = prev.includes(id);
      const updatedSelection = isSelected
        ? prev.filter((cid) => cid !== id) // Deselect candidate
        : [...prev, id]; // Select candidate

      // Update credit count based on selection
      setCreditCount((prevCredits) =>
        isSelected ? prevCredits - credit : prevCredits + credit
      );

      return updatedSelection;
    });
  };

  const selectAll = () => {
    if (selectedCandidates.length === allCandidates.length) {
      setSelectedCandidates([]);
      setCreditCount(0);
    } else {
      setSelectedCandidates(allCandidates.map((c) => c.id));
      const totalCredits = allCandidates.reduce((sum, c) => sum + c.credit, 0);
      setCreditCount(totalCredits);
    }
  };

  useEffect(() => {
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const handleOnClickMassmail = () => {
    let userData = {
      ...valueData,
      job_id: jobID?.job_id,
      send_both: false,
      candidate_resume_ids: selectedCandidates,
    };

    dispatch(postMassmail(userData));
  };

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const handleOnClickNextPrevious = (type) => {
    if (type === "next") {
      let url = candidateData?.next;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    } else {
      let url = candidateData?.previous;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    }
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };

  useEffect(() => {
    if (massmailStatus === "post_massmail_succeeded") {
      handleCloseModal();
      handleClose()
    }
  }, [massmailStatus]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "470px",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          All Active Candidate
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div>
          {allCandidates?.length > 0 &&
            allCandidates.map((candidate) => (
              <div
                key={candidate.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px",
                  border: "1px solid #f2f2f2",
                  borderRadius: "3px",
                  marginBottom: "8px",
                }}
              >
                <div>
                  <p style={{ marginBottom: "0" }}>
                    <b> {candidate?.full_name}</b> -{" "}
                    {candidate?.current_job_title}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "gray",
                      marginBottom: "0",
                    }}
                  >
                    {getPreferLocationNames(candidate?.prefer_location)}
                  </p>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "gray",
                      marginBottom: "0",
                    }}
                  >
                    {getWorkAuthorization(candidate?.work_authorization)}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    {formatDate(candidate?.created_at)}
                  </p>

                  <input
                    type="checkbox"
                    style={{
                      border: "1px solid #f2f2f2 !important",
                      cursor: "pointer",
                    }}
                    checked={selectedCandidates.includes(candidate.id)}
                    onChange={() =>
                      toggleSelect(candidate?.id, candidate?.credit)
                    }
                  />
                </div>
              </div>
            ))}
        </div>
        <Box
          className={styles.mass_update_btns}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <button
              style={
                candidateData?.previous === null
                  ? {
                      backgroundColor: "#3856a6",
                      marginRight: "10px",
                      cursor: "not-allowed",
                    }
                  : { backgroundColor: "#3856a6", marginRight: "10px" }
              }
              onClick={() => handleOnClickNextPrevious("previous")}
              disabled={candidateData?.previous === null}
            >
              {massmailStatus === "loading" ? "Loading" : "Prevoius"}
            </button>
            <button
              style={
                candidateData?.next === null
                  ? {
                      backgroundColor: "#3856a6",
                      marginRight: "0",
                      cursor: "not-allowed",
                    }
                  : { backgroundColor: "#3856a6", marginRight: "0" }
              }
              onClick={() => handleOnClickNextPrevious("next")}
              disabled={candidateData?.next === null}
            >
              {massmailStatus === "loading" ? "Loading" : "Next"}
            </button>
          </Box>
          <button
            onClick={selectAll}
            style={{
              padding: "8px 20px",
              backgroundColor: "#4287f5",
              color: "white",
              border: "none",
              borderRadius: "3px",
              cursor: "pointer",
            }}
          >
            {selectedCandidates?.length === allCandidates?.length
              ? "Deselect All"
              : "Select All"}
          </button>
        </Box>

        <Box
          className={styles.mass_update_btns}
          sx={{ justifyContent: "center", marginTop: "20px" }}
        >
          <button
            style={{ backgroundColor: "#4287f5", marginRight: "0" }}
            onClick={handleClickOpen}
          >
            Send Mail
          </button>
        </Box>
      </Offcanvas.Body>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        sx={{
          "& .MuiDialog-paper": { width: "40%", maxHeight: "90vh" },
          textAlign: "center",
        }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ color: "#3856a6", marginTop: "10px" }}
        >
          {"Massmail"}
        </DialogTitle>
        <DialogContent>{creditCount} credit will debit</DialogContent>

        <DialogActions className="forgot_password_modal_btns">
          <button type="submit" onClick={handleOnClickMassmail}>
            {massmailStatus === "loading" ? "Loading" : "Yes"}
          </button>
          <button type="submit" onClick={handleCloseModal}>
            No
          </button>
        </DialogActions>
      </Dialog>
    </Offcanvas>
  );
}

export default ActiveCandidateDrawer;
